import { useState } from "react";
import { faqItems } from "../../../mocks/hotNews";
import SectionHeading from "./SectionHeading";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqItems.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <section className="w-full bg-background-50 py-14 md:py-20">
        <div className="mx-auto w-full max-w-[1320px] px-4 md:px-6">
          <SectionHeading
            eyebrow="常见问题"
            title="围观前，先看看这些"
            desc="关于看料门的内容来源、现场直击、热度算法与投稿纠错，都在这边为你答疑。"
          />
          <div className="mx-auto max-w-3xl space-y-3">
            {faqItems.map((item, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={i}
                  className={`overflow-hidden rounded-2xl border transition-colors ${
                    open ? "border-primary-200 bg-background-100/60" : "border-background-200 bg-background-50"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3 text-sm font-bold text-foreground-900 md:text-base">
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-lg text-xs font-bold ${
                          open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                        }`}
                      >
                        Q{i + 1}
                      </span>
                      {item.q}
                    </span>
                    <i
                      className={`text-lg transition-transform duration-300 ${
                        open ? "rotate-45 text-primary-500" : "text-foreground-500"
                      } ${open ? "ri-close-line" : "ri-add-line"}`}
                    ></i>
                  </button>
                  <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-700">{item.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}